import { render, staticRenderFns } from "./paHealthParam.vue?vue&type=template&id=485e7388&"
import script from "./paHealthParam.vue?vue&type=script&lang=js&"
export * from "./paHealthParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports